import { render, staticRenderFns } from "./OrdersReadyScreen.vue?vue&type=template&id=b4f5000a&"
import script from "./OrdersReadyScreen.vue?vue&type=script&lang=js&"
export * from "./OrdersReadyScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports